'use client';
import { useState } from 'react';
import { Button } from '@nf/ui';
import {
	ArrowDownIcon,
	ArrowUpIcon,
} from '@/components/icons/svg-icons';
import { cx } from 'styled-system/css';
import { SportMatchModel } from '@nf/types/odds';
import { MyFavouritesMatchButton } from '@/features/my-favourites/components/my-favourites-match-button';
import { matchSpecialStyles } from '../match-special.style';
import { MatchTimer } from '@/features/sportsbook-aside/components/match-item/match-timer';
import { matchStyles } from '../../match/match.style';
import { MatchSpecialOption } from '../match-special-option/match-special-option';

interface MatchSpecialHeaderProps {
	match: SportMatchModel;
	showMatch: boolean;
	toggleMatch: () => void;
};
export const MatchSpecialHeader = ({ match, showMatch, toggleMatch } : MatchSpecialHeaderProps) => {
	const { MatchId, GameID, Ktm, Etm } = match;
	
	return (
		<div className={matchSpecialStyles.event}>
			<div className={cx(matchStyles.stats, matchSpecialStyles.stats)}>
				<MyFavouritesMatchButton matchId={MatchId} time={Ktm || Etm} sportType={GameID} />
				<div className="match-timer">
					<MatchTimer match={match} />
				</div>
			</div>
			<MatchSpecialOption match={match} />
			<Button variant="icon" className={matchStyles.arrowButton} onClick={toggleMatch}>
				{showMatch ? <ArrowUpIcon /> : <ArrowDownIcon />}
			</Button>
		</div>
	)
}